import { useEffect } from 'react'
import { useChurch } from './useChurch'
import { updatePWAMetaTags, updatePageTitle } from '@/lib/pwa'

interface OpenGraphPageData {
  title?: string
  description?: string
  image?: string
  type?: string
}

/**
 * Hook para gerenciar meta tags Open Graph e compartilhamento social por página
 */
export function useOpenGraph(pageData?: OpenGraphPageData) {
  const { church } = useChurch()

  useEffect(() => {
    // Atualizar título da página
    updatePageTitle(church, pageData?.title)
    
    // Atualizar meta tags PWA e Open Graph
    updatePWAMetaTags(church, pageData)
    
    console.log('🔗 Meta tags de compartilhamento atualizadas:', {
      church: church ? {
        nome: church.nome,
        descricao: church.descricao,
        id: church.id,
        logo_light: church.logo_light
      } : null,
      pageData,
      hasChurch: !!church
    })
  }, [church, pageData?.title, pageData?.description, pageData?.image, pageData?.type])

  return {
    church,
    pageData,
    /**
     * Função para gerar dados de compartilhamento para Web Share API
     */
    getShareData: (customData?: Partial<OpenGraphPageData & { url?: string }>) => {
      const currentUrl = customData?.url || window.location.href
      
      const title = customData?.title || pageData?.title || church?.nome || 'IgrejaDigital'
      const description = customData?.description || pageData?.description || church?.descricao || 'Sistema interno para gestão e engajamento de membros da igreja'
      
      return {
        title,
        text: description,
        url: currentUrl
      }
    }
  }
}